import { render, staticRenderFns } from "./JoinedForm.vue?vue&type=template&id=76b65322"
import script from "./JoinedForm.vue?vue&type=script&lang=js"
export * from "./JoinedForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports